<template>
	<div class="step step3">
		<step-header :current="3"></step-header>
	</div>
</template>
<script>
import stepHeader from "./stepHeader";

export default {
	components: {
		stepHeader
	}
};
</script>
